var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3909 12.0852L15.959 3.5498L7.06738 10.2501L13.75 18.5001L15.4278 17.3323L22.3909 12.0852Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0634 2.80711C16.2603 2.83479 16.4383 2.93959 16.558 3.09845L22.9899 11.6339C23.2391 11.9647 23.1731 12.4349 22.8422 12.6842L15.8791 17.9313C15.8716 17.937 15.864 17.9425 15.8562 17.9479L14.1784 19.1157C13.8558 19.3402 13.4146 19.2776 13.1672 18.9722L6.48459 10.7222C6.35652 10.5641 6.29819 10.3607 6.32297 10.1588C6.34775 9.95681 6.45353 9.77359 6.61602 9.65114L15.5076 2.95083C15.6665 2.83112 15.8664 2.77942 16.0634 2.80711ZM8.13909 10.3816L13.8939 17.4862L14.9877 16.7248L21.3405 11.9376L15.8114 4.60015L8.13909 10.3816Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08309 14.1914L7.7013 10.7114L6.79858 9.51343L1.5814 13.4448C1.25059 13.6941 1.1845 14.1644 1.43378 14.4952L4.64971 18.7629L4.64972 18.7629L5.94997 20.4884C6.09167 20.6764 6.31344 20.787 6.54889 20.787L11.8306 20.7874C12.0011 20.7874 12.1665 20.7293 12.2996 20.6228L14.2188 19.0854L13.281 17.9147L11.5674 19.2874L6.92289 19.287L5.84767 17.8602L5.84766 17.8602L3.08309 14.1914Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2829 20.7861L6.60303 20.7862C6.18882 20.7862 5.85303 20.4504 5.85303 20.0362C5.85303 19.622 6.18881 19.2862 6.60302 19.2862L22.2829 19.2861C22.6971 19.2861 23.0329 19.6219 23.0329 20.0361C23.0329 20.4503 22.6971 20.7861 22.2829 20.7861Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/Erase.9771661e.svg";
export { ForwardRef as ReactComponent };